export default __webpack_public_path__ + "static/media/FreightSmith_LOGO_Final.1fc22747.png";